module.exports = __webpack_public_path__ + "assets/img/chirp-search.6b34f061.svg";